<script> 
	import { onMount, onDestroy  }	from 'svelte';
	onMount(() => {
		let typing = new Typed('.lettering-typing', {
			strings: [ "condomínio", "imóvel", "patrimônio", "lugar" ],
			typeSpeed: 100,
			backSpeed: 40,
			loop: true,
		});
	});
</script>

<h2>A gestão inteligente<br class="hidden-sm hidden-xs" /> do seu <span class="color-primary-light lettering-typing"></span></h2>